var _circle, _circle2, _circle3, _path, _path2, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaugeIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "#192657"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.66667,
    transform: "matrix(1 0 0 -1 19.9987 19.9998)",
    stroke: "#1E334E",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 0.8,
    transform: "matrix(1 0 0 -1 32.5305 30.3997)",
    fill: "#FBFDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.797 20.2668H36.7971C36.7985 20.1779 36.7992 20.0889 36.7992 19.9997C36.7992 10.7213 29.2776 3.19971 19.9992 3.19971C10.7208 3.19971 3.19922 10.7213 3.19922 19.9997C3.19922 20.1783 3.20201 20.3563 3.20754 20.5336H4.20807C4.20218 20.3564 4.19922 20.1784 4.19922 19.9997C4.19922 11.2736 11.2731 4.19971 19.9992 4.19971C28.7253 4.19971 35.7992 11.2736 35.7992 19.9997C35.7992 20.0889 35.7985 20.1779 35.797 20.2668Z",
    fill: "#1E334E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7659 21.0664C35.5841 23.7951 34.7094 26.3341 33.3164 28.5093L34.153 29.0575C35.6492 26.7246 36.5844 23.9974 36.7681 21.0664H35.7659Z",
    fill: "#EF8127"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.0352,
    y1: 17.8667,
    x2: 20.0352,
    y2: 6.40003,
    stroke: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeIcon2);
export default __webpack_public_path__ + "static/media/gaugeIcon-2.60b56c3a2ca88f1aad9c371d28e780a4.svg";
export { ForwardRef as ReactComponent };